/* ===== Zendesk Trigger: Open Widget (START) ===== */
(() => {
  const ZENDESK_TRIGGER_SELECTOR = '.open-zendesk, [data-bstro-zendesk-open]';

  const openZendeskWidget = () => {
    if (typeof window.zE !== 'function') return;

    try {
      window.zE('webWidget', 'open');
    } catch (error) {
      try {
        window.zE('messenger', 'open');
      } catch (fallbackError) {
        // The Zendesk widget has not initialized or uses an unsupported API.
      }
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(ZENDESK_TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();
    openZendeskWidget();
  });
})();
/* ===== Zendesk Trigger: Open Widget (END) ===== */
